import isEmpty from '../helpers/isEmpty'
//-----------------------------
// get populated skill current
//-----------------------------
export default function getPopulatedSkillCurrent(args) {

  const base = args.base
  const parent = args.parent_name
  const parent_cur = args.parent_cur
  const ticks = args.ticks
  const training = args.training
  const adjs_tot = args.adjs_tot

  let cur

  // if child skill - show parent cur
  if (!isEmpty(parent)) {
    cur = parent + ' Cur (' + parent_cur + ') + Adjs Tot (' + adjs_tot + ')'
  } else {
    // else show std cur calcs fields
    cur =
      'Base (' + base + ') + Ticks (' + ticks + ') + Training (' + training + ') + Adjs Tot (' + adjs_tot + ')'
  }
  return cur
}
